@if(project(); as project) {
<pane-card>
    <card-header ngProjectAs="card-header">{{project.name()}} Package</card-header>
    <card-content ngProjectAs="card-main-content">
        <div class="export-package">
            <checkbox 
                [checked]="false" 
                [id]="'serviceMatrix'">
                Service Matrix
            </checkbox>

            <checkbox 
                [checked]="false" 
                [id]="'roomSummary'">
                Room Sumary Sheets
            </checkbox>

            <checkbox 
                [checked]="false" 
                [id]="'revitModels'">
                Revit Models
            </checkbox>

            <checkbox 
                [checked]="false" 
                [id]="'documents'">
                Associated Documents
            </checkbox>
        </div>

    </card-content>
    <card-content #cardBottom ngProjectAs="card-bottom-content">
      <div class="d-flex gap-2 mb-3">
        <div class="flex-fill">
             <is-busy-button id="button1" 
                    (execute)="exportCommand.execute()"
                    [isBusy]="exportCommand.isBusy()"
                    [disabled]="false"
                    css="btn w-100 clip3 corner position-relative primary-border secondary-bg secondary-text-100 font-4 rounded-0 py-2">
                <span>Create Package</span>
            </is-busy-button>
        </div>
        <div  class="flex-fill">
            <is-busy-button id="button3" 
                        (execute)="cancelCommand.execute()"
                        [disabled]="false" 
                        css="btn w-100 clip3 corner position-relative primary-border primary-text-100 font-4 rounded-0 py-2">
                    <span>Cancel</span>
            </is-busy-button>
        </div> 
      </div>
        
    </card-content>
</pane-card>

}